module.exports = __webpack_public_path__ + "static/media/Pokedex.79eacbe2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Pokedex.png
// module id = 266
// module chunks = 4